import { ProductMessage } from '../../../../types/ProductMessage';
import { ProductUnit } from '../../../../types/ProductUnit';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { IconButton } from '../../../cdl/IconButton/IconButton';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPencil } from '../../../common/icons/cdl/Pencil';
import { useProductUpdate } from '../hooks/useProductUpdate';

import { ProductFormState } from './ProductBaseForm';
import { ProductForm } from './ProductForm';

interface UpdateProductButtonProps {
    product: ProductMessage;
}

export const UpdateProductButton = (props: UpdateProductButtonProps) => {
    const { push, pop } = useDrawer();
    const { addToast, addErrorToast } = useToasts();
    const productUpdateMutation = useProductUpdate();

    const onEditButtonClick = () => {
        const onSubmit = async (values: ProductFormState) => {
            return productUpdateMutation.mutateAsync(
                {
                    product: {
                        supplierProductGroup: values.supplierProductGroup,
                        name: values.name,
                        group: values.group,
                        packTypeDefault: values.packTypeDefault,
                        unitDefault: values.unitDefault as ProductUnit,
                    },
                    id: props.product.id,
                },
                {
                    onSuccess: () => {
                        addToast(translate('productsOverview.updateSuccessToast'));
                        pop(drawerId);
                    },
                    onError: () => {
                        addErrorToast(translate('productsOverview.updateErrorToast'));
                    },
                }
            );
        };

        const drawerId = push({
            header: { title: translate('productsOverview.editProduct') },
            content: (
                <ProductForm
                    onSubmit={onSubmit}
                    product={props.product}
                    initialState={{
                        supplierProductGroup: props.product.supplierProductGroup,
                        name: props.product.name,
                        group: props.product.group,
                        packTypeDefault: props.product.packTypeDefault,
                        unitDefault: props.product.unitDefault,
                    }}
                />
            ),
        });
    };

    return (
        <IconButton
            Icon={IconPencil}
            onClick={onEditButtonClick}
            tooltipLabel={translate('productsOverview.editProduct')}
        />
    );
};
